<template>
    <!-- 生日西元民國切換功能 -->
    <div id="yearChange">
        <div class="inputTitle" :class="{ 'pinkText': startCheck&&check1 }">出生日期</div>
        <div class="birthdayLine">
            <label class="switch">
                <input type="checkbox" class="switch-input" @click="changeYear">
                <span class="switch-label" data-on="西元" data-off="民國"></span>
                <span class="switch-handle"></span>
            </label>
            <!--ROC民國-->
            <div class="  clarity-mask inputWrapper"  :class="{ 'alert': startCheck&&check1 }" v-if="yearChange">
                <input id="birthday_ROC" class="inputStyle ROC"  v-model="rocDateStr" type="password" maxlength="9" placeholder="YYY/MM/DD" @change="formatDate" @keyup="upper">
                <div v-if="isMasked_ROC" @click="toggleMask" class="eyeIcon"> <img alt="" src="../assets/close.svg"></div>
                <div  v-else @click="toggleMask" class="eyeIcon"> <img alt="" src="../assets/open.svg"></div>
            </div>
            <!--EC西元-->
            <div class=" clarity-mask inputWrapper" :class="{ 'alert': startCheck&&check1 }" v-else>
                <input id="birthday_EC" class="inputStyle" v-model="ecDateStr" type="password" maxlength="10" placeholder="YYYY/MM/DD" @change="formatDate" @keyup="upper">
                <div  v-if="isMasked_EC" @click="toggleMask" class="eyeIcon"> <img alt="" src="../assets/close.svg"></div>
                <div  v-else @click="toggleMask" class="eyeIcon"> <img alt="" src="../assets/open.svg"></div>
            </div>

            <p class="alertStr"></p>
        </div>
    </div>
</template>
<script setup>
import {onMounted, ref, defineProps,defineEmits} from "vue";
import moment from "moment/moment";
import CheckData from "@/utils/checkData";

const props = defineProps({
    dateTimeProps: Object,
    nickName: String,
});
const emit = defineEmits(['getDateTime']);

let startCheck = ref(false);
const yearChange = ref(false)//false:西元 true:民國
const rocDateStr = ref();
const ecDateStr = ref()
let birthday = null;
const check1 = ref(false)
const isMasked_ROC = ref(true); // 隱碼狀態
const isMasked_EC = ref(true); // 隱碼狀態
let dateTime = {
    year: '',
    yearROC: '',
    month: '',
    date: '',
    fullDateTime: ''
}

const changeYear = () => {
    yearChange.value = !yearChange.value;
    isMasked_ROC.value = true;
    isMasked_EC.value = true;
}
const loadDateTime = () => {
    dateTime.year = props.dateTimeProps.year ? props.dateTimeProps.year : '';
    dateTime.month = props.dateTimeProps.month ? props.dateTimeProps.month : '';
    dateTime.date = props.dateTimeProps.date ? props.dateTimeProps.date : '';
    if (dateTime.year !== '' && dateTime.month !== '' && dateTime.date !== '') {
        yearChange.value = false;
        ecDateStr.value = dateTime.year + '/' + addZeroStr(dateTime.month, 2) + '/' + addZeroStr(dateTime.date, 2);
        formatDate();
    }
}

const formatDate = () => {
    if(!yearChange.value){
        if(ecDateStr.value){
            if(ecDateStr.value.length === 8 || ecDateStr.value.length === 10){
                birthday = moment(ecDateStr.value).toDate();
                if(moment(birthday).isValid()) {
                    ecDateStr.value = moment(ecDateStr.value).format('YYYY/MM/DD');
                    rocDateStr.value = addZeroStr(birthday.getFullYear() - 1911, 3) + '/' + addZeroStr(birthday.getMonth() + 1, 2) + '/' + addZeroStr(birthday.getDate(), 2);
                    check1.value = false;
                }else{
                    check1.value = true;
                    rocDateStr.value = '';
                }
            }else{
                check1.value = true;
                rocDateStr.value = '';
            }
        }else{
            check1.value = true;
            rocDateStr.value = '';
        }
    }else{
        if(rocDateStr.value){
            rocDateStr.value = rocDateStr.value.replace(/[^0-9]/g, '');//清除非數字字串

            if(rocDateStr.value.length === 6) {
                rocDateStr.value = addZeroStr(rocDateStr.value, 7);
            }

            if(rocDateStr.value.length === 7 || rocDateStr.value.length === 9){
                let year = rocDateStr.value.substring(0, 3);
                let month = rocDateStr.value.substring(3, 5);
                let day = rocDateStr.value.substring(5, 7);
                birthday = moment(parseInt(year) + 1911 + "/" + month + "/" + day, 'YYYY/MM/DD').toDate();
                if(moment(birthday).isValid()) {
                    rocDateStr.value = year + "/" + month + "/" + day;
                    ecDateStr.value = birthday.getFullYear() + '/' + addZeroStr(birthday.getMonth() + 1, 2) + '/' + addZeroStr(birthday.getDate(), 2);
                    check1.value = false;
                }else{
                    check1.value = true;
                    ecDateStr.value = '';
                }
            }else{
                check1.value = true;
                ecDateStr.value = '';
            }
        }else{
            check1.value = true;
            ecDateStr.value = '';
        }
    }
    setDateTime()
}

const setDateTime = () => {
    if (check1.value === false) {
        dateTime.year = birthday.getFullYear();
        dateTime.yearROC = birthday.getFullYear() - 1911;
        dateTime.month = addZeroStr(birthday.getMonth() + 1, 2);
        dateTime.date = addZeroStr(birthday.getDate(), 2);
        dateTime.fullDateTime = moment(birthday).format('YYYY-MM-DD');
    }else{
        dateTime.year = '';
        dateTime.yearROC = '';
        dateTime.month = '';
        dateTime.date = '';
        dateTime.fullDateTime = '';
    }
    emit('getDateTime', dateTime);
}
// 切換隱碼狀態
const toggleMask = () => {
    const birthdayROC_ID = document.getElementById("birthday_ROC") ;
    const birthdayEC_ID = document.getElementById("birthday_EC") ;
    if (birthdayROC_ID) {
        const currentTypeROC = birthdayROC_ID.getAttribute("type");
        birthdayROC_ID.setAttribute("type", currentTypeROC === "password" ? "text" : "password");
        isMasked_ROC.value = !isMasked_ROC.value;
    }

    if (birthdayEC_ID) {
        const currentTypeEC = birthdayEC_ID.getAttribute("type");
        birthdayEC_ID.setAttribute("type", currentTypeEC === "password" ? "text" : "password");
        isMasked_EC.value = !isMasked_EC.value;
    }
};
const addZeroStr = (value, length) => {
    value = value + '';
    if (value.length < length) {
        let count = length - value.length
        for (let i = 0; i < count; i++) {
            value = '0' + value;
        }
    }
    return value;
}

const checkForm = (st) => {
    if (st === true) {
        startCheck.value = true;
    }
}

const upper = () =>{
    if(rocDateStr.value){
        rocDateStr.value = CheckData.convertToHalfWidth(rocDateStr.value);
    }
    if(ecDateStr.value){
        ecDateStr.value = CheckData.convertToHalfWidth(ecDateStr.value);
    }
}

defineExpose({checkForm}) //父組件需使用

onMounted(() => {
    loadDateTime();
})

</script>

<style lang="scss">
#yearChange {
    text-align: left;
}

.birthdayLine {
    margin: 0 0 20px;
    position: relative;
    vertical-align: top;
    display: flex;

    .inputStyle {
        width: 70%;
        display: inline-block;
        vertical-align: top;
        @media screen and (max-width: $mobile-small) {
            width: 59%;
        }

        .input {
            display: inline-block;

            &:last-of-type {
                span {
                    display: none
                }
            }
        }

        input {
            border: 0;
            background: transparent;
            height: 100%;
            @media screen and (max-width: $mobile-small) {
                padding: 0;
                height: 100%;
            }

            &.inputYear {
                width: 3em;
            }

            &.inputMonth,
            &.inputDay {
                width: 1.8em
            }
        }

        &.ROC {
            .inputYear {
                width: 2.3em
            }
        }
    }
    .eyeIcon {
        position: absolute;
        right: 10px;
        cursor: pointer;
        margin-right: 10px;
        margin-top: 10px;
    }
    .inputWrapper {
        display: flex;
        align-items: center;
        position: relative;
        flex-direction: column;
        width: calc(100% - 140px);
    }
}

.oneline {
    margin: 10px 0
}

.switch {
    display: inline-block;
    position: relative;
    min-width: 140px;
    margin-right: 2%;
    height: 40px;
    background-color: white;
    border-radius: 40px;
    cursor: pointer;
}

.switch-input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;

    &:checked {
        ~ .switch-label:before {
            color: #fff;
        }

        ~ .switch-label:after {
            color: $black;
        }

        ~ .switch-handle {
            left: 50%;
        }
    }
}

.switch-label {
    position: relative;
    z-index: 500;
    display: block;
    height: inherit;
    font-size: 16px;
    font-weight: 500;
    text-transform: uppercase;
    color: $black;
    border-radius: inherit;
    border: 1px solid $gray-600;
    -webkit-transition: 0.15s ease-out;
    -moz-transition: 0.15s ease-out;
    -o-transition: 0.15s ease-out;
    transition: 0.15s ease-out;
    //-webkit-transition-property: opacity background;
    //-moz-transition-property: opacity background;
    //-o-transition-property: opacity background;
    //transition-property: opacity background;
    box-sizing: border-box;

    &:before,
    &:after {
        position: absolute;
        line-height: 40px;
        transition: inherit;
    }

    &:before {
        content: attr(data-off);
        right: 15%;
        color: $black;

        @media screen and (max-width: $mobile-small) {
            right: 13%;
        }
    }

    &:after {
        content: attr(data-on);
        left: 12%;
        color: #fff;

        @media screen and (max-width: $mobile-small) {
            left: 13%;
        }
    }
}

.switch-handle {
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 40px;
    background-color: $blue-700;
    border-radius: 40px;
    box-shadow: 1px 1px 5px rgb(0 0 0 / 20%);
    transition: left 0.15s ease-out;
    @media screen and (max-width: $mobile-small) {
        width: 50%;
    }
}
</style>